<template>
    <clients-section title="They Chose Us|Ils nous ont choisis">
        <client-card src="img/clients-color/transportation/autobus-breton.png">
            Autobus Breton
        </client-card>
        <client-card src="img/clients-color/transportation/autocar_preferences.png">
            Autocar Préférences
        </client-card>
        <client-card src="img/clients-color/transportation/bell-horizon.png">
            Bell Horizon
        </client-card>
        <client-card src="img/clients-color/transportation/blus.png">
            Blue
        </client-card>
        <client-card src="img/clients-color/transportation/foley-bus-lines.png">
            Foley Bus Lines
        </client-card>
        <client-card src="img/clients-color/transportation/fleur_lys.png">
            Fleur de Lys
        </client-card>
        <client-card src="img/clients-color/transportation/autobus-galland.png">
            Galland
        </client-card>
        <client-card src="img/clients-color/transportation/king_charters.png" bg>
            King Charters
        </client-card>
        <client-card src="img/clients-color/transportation/king_tours.png" bg>
            King Tours
        </client-card>
        <client-card src="img/clients-color/transportation/leduc.png">
            Leduc Busline
        </client-card>
        <client-card src="img/clients-color/transportation/limocar.png">
            Limocar
        </client-card>
        <client-card src="img/clients-color/transportation/magic-bus-company.png" bg>
            Magic Bus Company
        </client-card>
        <client-card src="img/clients-color/transportation/quick_coach_shuttle.png">
            Quick Coach Shuttle
        </client-card>
        <client-card src="img/clients-color/transportation/rider-express.png">
            Rider Express
        </client-card>
        <client-card src="img/clients-color/transportation/silent-rides.png">
            Silent Rides
        </client-card>
        <client-card src="img/clients-color/transportation/south-sask-bus-lines.png">
            South Sask Bus Lines
        </client-card>
        <client-card src="img/clients-color/transportation/stm.png">
            STM
        </client-card>
        <client-card src="img/clients-color/transportation/transdev.png">
            Transdev
        </client-card>
        <client-card src="img/clients-color/transportation/vbl.png" bg>
            VBl
        </client-card>
        <client-card src="img/clients-color/transportation/veolia.png">
            Veolia
        </client-card>
    </clients-section>
</template>

<script>

import ClientCard from "@/components/client-card.vue";
import ClientsSection from "@/components/clients-section.vue";
export default {
    name: `wifi-transportation-client-cards`,
    components: {ClientCard, ClientsSection},
    data() {
        return {
            altPrefix: this.tr(`Bus and Transportation client guest wifi|Client bus et transports wifi social`)
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
